<template>
  <div>
    <h3>支付密码</h3>
    <div class="code">
      <div class="time clearfix">
        <div class="name">手机号:</div>
        <div class="stripsss">
          <el-input type="text" :value="mobile" disabled class="text"></el-input>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name">验证码:</div>
        <div class="item">
          <input class="fl text" type="text" name="uname" placeholder="输入验证码" v-model="sms" />
          <div class="fl timebs">
            <div class="stars" @click="start">
              <em v-show="xian==0">获取验证码</em>
              <em v-show="xian==2">重新获取</em>
            </div>
            <van-count-down
              ref="countDown"
              :time="time"
              format=" ss 秒"
              @pause="pause"
              @reset="reset"
              @finish="finish"
              :auto-start="false"
              v-show="xian==1"
            >
              <template v-slot="timeData">
                <div class="itemsss">{{ timeData.seconds }}s</div>
              </template>
            </van-count-down>
          </div>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name">密码：</div>
        <div class="stripsss">
          <el-input type="password" v-model="password" placeholder="输入新密码" class="text"></el-input>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name"></div>
        <div class="stripsss" @click="register">
          <span>完成</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Upload, Input, Message } from "element-ui";
import utilFile from "@/ace/ace.js";
import { CountDown } from "vant";
export default {
  components: {
    [Input.name]: Input,
    [Message.name]: Message,
    [CountDown.name]: CountDown
  },
  data() {
    return {
      value: null,
      sms: null,
      password: null,
      time: 60 * 1000,
      xian: 0,
      mobile: null
    };
  },
  inject: ["reload"], // 引入方法
  methods: {
    start() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;

      var data = utilFile.encrypt(
        JSON.stringify({
          phone: this.mobile,
          purpose: 3 //1注册，2忘记密码，3支付密码
        })
      );

      this.$axios({
        method: "post",
        url: `/api/authority.getcode?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.xian = 1;
          this.$refs.countDown.start();
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
        } else if (res.data.code == 999) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
          this.finish();
        } else {
          Message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
          this.finish();
        }
      });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.xian = 2;
      this.reset();
    },
    register() {
      if (this.sms != null && this.password != null) {
        if (this.password.length == 6) {
          var data = utilFile.encrypt(
            JSON.stringify({
              phone: this.mobile,
              code: this.sms,
              paypwd: this.password
            })
          );

          this.$axios({
            method: "post",
            url: `/api/authority.setpaypwd?parameter=${data}`,
            data: {},
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
          }).then(res => {
            if (res.data.code == 200) {
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "success"
              });
              localStorage.setItem("isSetPayPwd", 1); //设置支付密码成功后修改缓存值
              setTimeout(() => {
                this.reload();
              }, 1000);
            } else {
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "warning"
              });
            }
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: "密码长度为6位",
            type: "warning"
          });
        }
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "不能为空",
          type: "warning"
        });
      }
    },
    user() {
      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          let userinfo = JSON.parse(utilFile.decrypt(res.data.data));
          this.mobile = userinfo.phone;
        }
      });
    },
    
  },
  mounted() {
    this.user();
  }
};
</script>

<style scoped>
h3 {
  font-size: 16px;
  color: #000;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf1f2;
  margin-top: 26px;
}

.avatar-uploader {
  width: 100%;
  height: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}

.code {
  box-sizing: border-box;
  padding-left: 183px;
  padding-top: 67px;
}

.code .time {
  margin-bottom: 56px;
}

.code .time .name {
  font-size: 14px;
  color: #000;
  margin-right: 18px;
  float: left;
  line-height: 33px;
  width: 70px;
  text-align: right;
}

.code .stripsss {
  float: left;
  cursor: pointer;
}

.code .stripsss .headerimg {
  width: 102px;
  height: 102px;
  overflow: hidden;
  margin-left: 54px;
}

.code .text {
  width: 320px;
  height: 33px;
  line-height: 33px;
}

.code .stripsss span {
  display: block;
  width: 90px;
  line-height: 36px;
  background-color: #38a0ff;
  color: #ffffff;
  border-radius: 50px;
  text-align: center;
  margin-left: 90px;
}

.item {
  width: 320px;
  border: 1px solid #d9dde1;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px 5px;
  overflow: hidden;
  cursor: pointer;
}

.item.zhmm {
  text-align: right;
  font-size: 14px;
  line-height: 33px;
  color: #bababa;
  border: 0px;
}

.code .item input {
  height: 33px;
  border: 0px;
  width: 250px;
  float: left;
  box-sizing: border-box;
  padding: 0 15px;
}

.item i.uname {
  width: 33px;
  height: 33px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico1.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.item i.pwd {
  width: 33px;
  height: 33px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico2.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.item i.codeddd {
  width: 33px;
  height: 33px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/code_03.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.timebs {
  position: relative;
}

.item .stars {
  width: 68px;
  line-height: 26px;
  height: 26px;
  border: 1px solid #3aacfe;
  text-align: center;
  border-radius: 6px;
  font-size: 12px;
  margin-top: 3px;
}

.itemsss {
  line-height: 22px;
  cursor: pointer;
  text-align: center;
}

.ems {
  margin-top: 18px;
}

.ems em {
  color: #379dff;
}
</style>
<style>
.code .text .el-input__inner {
  height: 33px;
  line-height: 33px;
}
.item .van-count-down {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border: 0;
  padding: 0;
  line-height: 26px;
  padding-top: 6px;
  box-sizing: border-box;
}
</style>